import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'root/view/base';

var Zapier = View.extend({
    className: 'box-medium box-integration',

    events: {
        'click .view'           : 'view',
        'click .view-templates' : 'viewTemplates',
        'click .upgrade'        : 'upgrade'
    },

    dom_handlers: {
        view: function(e) {
            if (Cache.account.hasFeature('zapier')) {
                window.open('https://zapier.com/app/zaps', '_blank');
            } else {
                Modals.unlockFeature();
            }
        },

        viewTemplates: function(e) {
            e.preventDefault();
            Modals.viewZapierTemplates();
        },

        upgrade: function(e) {
            e.preventDefault();
            Modals.choosePlan();
        }
    },

    render: function() {
        var content =
        '<div class="thumbnail">' +
            '<img src="/image/zapier_small.png">' +
        '</div>' +
        '<div class="content">' +
            '<h3>Zapier</h3>' +
            '<div>Automate your workflows by connecting Userback with <a href="https://zapier.com/apps/userback/integrations" target="_blank">2000+ apps</a>.</div>' +
            (Cache.account.hasFeature('zapier') ?
            '<div class="margin-top-4"><a href="#" class="view-templates">View our most popular integrations</a>.</div>' :
            '<div class="margin-top-4"><a href="#" class="upgrade">Upgrade your account plan to use Zapier</a>.</div>') +
        '</div>' +
        '<div class="action">' +
            '<button type="button" class="tertiary small view">' + (Cache.account.hasFeature('zapier') ? 'View my Zaps' : 'Visit Zapier') + '</button>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});

export default Zapier;